// utils/getCountryCode.js
export const getUserCountryCode = async () => {
  // return "BG";
  try {
    const res = await fetch("https://ipinfo.io/json?token=42775533953eb0");
    const data = await res.json();
    console.log(data, "my ciuntry");

    return data.country; // e.g., "AE"
  } catch (err) {
    console.error("Error fetching user country code", err);
    return null;
  }
};
